import { atom } from 'jotai'

type Input = {
  isShow: boolean
  projectId: string | undefined
  applicationId: string | undefined
}

const state = atom<Input>({
  isShow: false,
  projectId: undefined,
  applicationId: undefined,
})
export const downloadGeneralContractorOrderXlsmStore = { state } as const
